import { communiqueListDtoToCommunicationList, communiqueListItemDtoToCommunicationListItem, comuniqueBaseMapper, ComuniqueCatDtoToComuniqueCat, } from '../../mappers/comunique';
import { getCurrentGroupId } from '../../utils/functions';
import { api } from './api';
export const FaqApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getComuniques: builder.query({
            query: params => ({
                method: 'get',
                url: '/api/Comunicado',
                params: {
                    titulo: params.term,
                    categorias: params.filteredOption,
                    dataFinal: params.endDate,
                    dataInicial: params.startDate,
                    page: params.page || 1,
                    limit: params.quantity || 5,
                },
            }),
            providesTags: ['Communique'],
            transformResponse: (response) => communiqueListDtoToCommunicationList(response),
        }),
        getCommunique: builder.query({
            query: ({ id }) => ({
                url: `api/Comunicado/${id}`,
                method: 'get',
            }),
            transformResponse: (response) => communiqueListItemDtoToCommunicationListItem(response),
        }),
        addCommunique: builder.mutation({
            query: formData => ({
                url: 'api/Comunicado/',
                method: 'post',
                data: formData,
            }),
            invalidatesTags: ['Communique'],
        }),
        updateCommunique: builder.mutation({
            query: ({ id, data }) => ({
                url: `api/Comunicado/${id}`,
                method: 'patch',
                data,
            }),
            invalidatesTags: ['Communique'],
        }),
        deleteCommunique: builder.mutation({
            query: ({ id }) => ({
                url: `api/Comunicado/${id}`,
                method: 'delete',
            }),
            invalidatesTags: ['Communique'],
        }),
        getBaseComuniques: builder.query({
            query: () => ({
                method: 'get',
                url: '/api/Comunicado/EmAndamento',
                params: {
                    grupoid: getCurrentGroupId(),
                },
                providesTags: ['Communique'],
            }),
            transformResponse: (response) => comuniqueBaseMapper(response),
        }),
        getComuniqueCat: builder.query({
            query: () => ({
                url: 'api/ComunicadoCat/',
                method: 'get',
            }),
            providesTags: ['Category'],
            transformResponse: (response) => ComuniqueCatDtoToComuniqueCat(response),
        }),
        addCommuniqueCat: builder.mutation({
            query: item => ({
                url: 'api/ComunicadoCat',
                method: 'post',
                data: {
                    Titulo: item.title,
                    Cor: item.color,
                },
            }),
            invalidatesTags: ['Category'],
        }),
        deleteCommuniqueCat: builder.mutation({
            query: ({ id }) => ({
                url: `api/ComunicadoCat/${id}`,
                method: 'delete',
            }),
            invalidatesTags: ['Category'],
        }),
        sendFeedBack: builder.mutation({
            query: ({ rate, message, id }) => ({
                url: `api/ComunicadoCat/${id}`,
                method: 'post',
                data: {
                    rate,
                    message,
                },
            }),
        }),
    }),
});
export const { useLazyGetComuniquesQuery, useAddCommuniqueCatMutation, useAddCommuniqueMutation, useDeleteCommuniqueCatMutation, useGetBaseComuniquesQuery, useDeleteCommuniqueMutation, useGetComuniqueCatQuery, useLazyGetCommuniqueQuery, useGetComuniquesQuery, useUpdateCommuniqueMutation, useSendFeedBackMutation, } = FaqApi;
